// src/context/AdminAuthContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { installGlobalAuthFetch, syncAxiosAuthHeader } from '../utils/authHeaders';

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [hydrated, setHydrated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedAdmin = localStorage.getItem('admin');
    if (storedAdmin) {
      setAdmin(JSON.parse(storedAdmin));
    }
    setHydrated(true);
  }, []);

  useEffect(() => {
    installGlobalAuthFetch();
    syncAxiosAuthHeader();
  }, []);

  useEffect(() => {
    syncAxiosAuthHeader();
  }, [admin]);

   useEffect(() => {
    if (!hydrated) {
      return;
    }

    if (admin === null) {
      navigate('/admin/login', { replace: true });
    }
  }, [admin, navigate, hydrated]);

  return (
    <AdminAuthContext.Provider value={{ admin, setAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

// Correct named export (make sure this line exists exactly like this)
export const useAdminAuth = () => useContext(AdminAuthContext);
